import TruckIcon from "../../assets/icons/truck-02.svg?react";
import { ServiceDetail } from "../../types/tracking/serviceDetail";
import { SpecialHandling } from "../../types/tracking/specialHandling";
import { TrackingListElem } from "./trackingListElem";

type TrackingServicesProps = {
  serviceDetail: ServiceDetail;
  specialHandlings: SpecialHandling[];
  locale: string;
};

export const TrackingServices = ({
  serviceDetail,
  specialHandlings,
  locale,
}: TrackingServicesProps) => {
  const serviceDetailValue = serviceDetail?.description || "";
  const specialHandlingsValue =
    specialHandlings?.map((specialHandling) => specialHandling.description).join(", ") || "";

  return (
    <div className="flex w-full flex-col gap-5 rounded-xl border border-gray-200 bg-white p-6 shadow-xs">
      <div className="flex w-full flex-row items-center gap-4">
        <TruckIcon width={24} height={24} />
        <span className="text-sm font-semibold text-black">Services</span>
      </div>
      <div className="flex w-full flex-col gap-0">
        <TrackingListElem name="Service" value={serviceDetailValue} />
        <TrackingListElem
          name={locale === "fr" ? "Section de manutention spéciale" : "Special handling"}
          value={specialHandlingsValue}
          last
        />
      </div>
    </div>
  );
};
